import type { ErrorCode } from '@nadoutong/contracts';
import { PlatformApiError } from '../../api/client.ts';
import { localizeApiError } from '../../api/errorMessages.ts';
import type { MessageKey } from '../../api/errorMessages.ts';
import type { I18nKey } from '../../i18n/index.ts';

/**
 * Flow-specific copy for auth failures a customer is supposed to hit.
 * Codes absent from `keys` fall through to the central `error.code.*`
 * table. Nothing here returns the wire `CODE: message`.
 */

export type AuthErrorKeys = Partial<Record<ErrorCode, I18nKey>>;

export function localizeAuthError(
  err: unknown,
  translate: (key: MessageKey) => string,
  keys: AuthErrorKeys,
): string {
  return localizeApiError(err, translate, keys);
}

/** True when the failure is specifically "this email already has an account". */
export function isAlreadyRegistered(err: unknown): boolean {
  return err instanceof PlatformApiError && err.code === 'EMAIL_ALREADY_REGISTERED';
}

export function isEmailNotVerified(err: unknown): boolean {
  return err instanceof PlatformApiError && err.code === 'EMAIL_NOT_VERIFIED';
}
